<template>
  <div class="about_box">
    <div class="threepart kctspart">
      <img src="../../assets/images/kcts.jpg" alt="">
      <div class="content course">
        <div class="title">
          <!-- <img src="../../assets/images/title/gnkc.png" alt=""> -->
          <!-- <p class="title_transition">Curriculum Modules</p> -->
        </div>
        <div class="textbox">
          <b>Information Science</b>
          <p>Artificial Intelligence, Computer Science, Communication, Digital Media, etc</p>
          <b>Physical Science</b>
          <p>Physics, Chemistry, Quantum Science, etc</p>
          <b>Geoscience & Life Science</b>
          <p>Genetics, Brain Science, Environmental Science, Biopharmacy, etc</p>
          <b>General Science & Liberal Arts</b>
          <p>History of Science, Methodology, and tailored courses regarding local cultures</p>
          <b>Mathematics</b>
          <p>Fundamental Mathematics, Applied Mathematics, Computational Mathematics, Probability and Statistics, Engineering Science, etc</p>
        </div>
      </div>
      <div class="zsxx_wrapper">
        <div id="zsxx">
          <div class="title">
            <img src="../../assets/images/title/zsxx.png" alt="">
            <p class="slogan">Beyond our major courses,  GASA provides other lifelong learning services for our community.</p>
          </div>
          <div class="content ">
            <div class="items">
              <div class="item" v-for="item in zsxxList" :key="item.id">
                <div class="top">
                  <img :src="item.img_url" alt="">
                  <div class="zs_title">{{item.title}}</div>
                  <div class="zs_intro">{{item.intro}}</div>
                </div>
                <div class="speakers" v-if="item.speakers.length > 0">
                  <div class="speaker" v-for="speaker in item.speakers" :key="speaker.id">
                    <img :src="speaker.img_url" alt="">
                    <div class="speaker_intro">
                      <div class="speaker_name">{{speaker.name}}</div>
                      <div class="speaker_title">{{speaker.title}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "about.page.less";
</style>
<style lang="less" scoped>
.about_box{
  .kctspart{
    .content .textbox{
      width: 55%;
    }
  }
  .threepart .content {
    height: fit-content;
    .title {
      width: 80%;
      font-size: 0;
      padding: 10px 0 30px 0;
      margin: 0 auto;
    }
  }
}
@media screen and (max-width:750px){
  .about_box{
  .kctspart{
    margin-top:50px;
    img{
      width: 100%;
    }
    .content{
    // remove
    .title_transition {
      font-size: 22px;
    }
      .title {
        width: 100%;
        font-size: 0;
        padding: 10px 0;
        margin: 0 auto;
        .remove {
          margin-top: 20px;
          font-size: 16px;
        }
      }
      .textbox{
        padding:0;
        width: 90%;
        margin:0 auto;
        text-align: left;
        b{
          line-height:32px;
          font-size: 14px;
          color:#000;
        }
        p{
          margin-bottom: 35px;
          font-size: 12px;
          line-height: 1.2;
        }
      }
    }
    .zsxx_wrapper {
      width: 100%;
    }
    #zsxx{
      .slogan {
        width: 100%;
      }
      .title {
        padding: 10px 0;
        p {
          font-size: 14px;
          margin-top: 10px;
        }
        img {
          height: 40px;
          object-fit: cover;
        }
      }
      .content {
        width: 90%;
        margin: 0 auto;
        padding-top: 10px;
        .items {
          .item {
            .top{
              text-align: left;
              .zs_title{
                font-size: 14px;
                padding:15px 0 10px 0;
              }
              .zs_intro{
                padding: 0 10px;
                color:#333;
                line-height: 1.5;
                text-align: left;
              }
            }
          }
        }
      }
    }
  }
}
}
.title_transition {
  font-size: 24px;
  font-weight: 700;
  color: #000;
}
#zsxx{
  .title p.slogan {
    width: 55%;
    margin: 0 auto;
    // font-size: 14px;
    margin-top: 10px;
  }
  .content{
    width: 55%;
    margin: 0 auto;
    
    .items{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-content: center;
      .item{
        // width: 33%;
        width: 49%;
        padding-bottom: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-content: center;
        img{
          border-radius: 5px;
          width: 100%;
        }
        .top{
          text-align: left;
          .zs_title{
            font-size: 18px;
            font-weight: bold;
            color:#20459d;
            padding:15px 0 10px 0;
            text-align: center;
          }
          .zs_intro{
            padding:0 2px 0px 2px;
            font-size: 14px;
            color:#333;
            line-height: 1.8;
            text-align: left;
          }
        }
        .speakers{
          .speaker{
            display: flex;
            justify-content: center;
            align-items: center;
            img{
              width: 50px;
              border-radius: 100%;
            }
            .speaker_intro{
              width: calc(100% - 50px);
              text-align: left;
              padding-left: 10px;
              .speaker_name{
                font-size: 14px;
                font-weight: bold;
                color: #333;
                margin-bottom: 5px;
              }
              .speaker_title{
                font-size: 12px;
                color:#666;
              }
            }
          }
        }
      }
    }
  }
  .title{
    width: 100%;
    font-size: 0;
    padding: 50px 0 30px 0;
    img{
      width: 100%;
    }
    p{
      font-size: 16px;
      margin-bottom: 0;
      margin-top: 20px;
      color:#666;
    }
  }
}
</style>
<script>
export default {
  data () {
    return {
      thisindex: 0,
      id: '',
      zsxxList: [
        {
          id: 3,
          img_url: '/static/zsxx/sxk.jpg',
          title: '',
          intro: `3-hour lecture session on up-to-date science and technology topics`,
          speakers: []
        },
        {
          id: 4,
          img_url: '/static/zsxx/gsyh.jpg',
          title: '',
          intro: 'High-level, cross-industry panels & fireside sessions with unbeatable networking opportunities',
          speakers: []
        }
        // {
        //   id: 5,
        //   img_url: '/static/zsxx/kxxdl.jpg',
        //   title: 'Science Relativity',
        //   intro: `GASA University scientific relativistic podcast, listen to scientists' gossip together, and make friends with scientists who are popular in the world.`,
        //   speakers: []
        // }
      ]
    }
  },
  created () {
    let id = this.$route.params.id
    console.log(1111111)
    console.log(id)
    this.thisindex = parseInt(id)
    // console.log(this.thisindex)
  },
  watch: {
    $route () {
      this.id = this.$route.params.id
    },
    id () {
      this.thisindex = parseInt(this.id)
    }
  },
  methods: {
    changeModal: function (modalnum) {
      this.thisindex = modalnum
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/pages/about/kcts.vue